import { CheckoutError } from '../checkout/checkout.types';
import type { CheckoutPreviewResponseDto } from './checkoutConfig.types';

/**
 * Busca o payload composto de prévia (`checkout` + `storeContact` + `paymentBadges`)
 * do checkout (rascunho ou publicado) identificado por `nanoId`.
 * Rota pública no backend (`GET /store-checkouts/preview/:nanoId`), protegida só pela
 * imprevisibilidade do nanoId — mesmo padrão de segurança de `fetchCheckoutOffer`.
 */
export async function fetchCheckoutPreview(nanoId: string): Promise<CheckoutPreviewResponseDto> {
  if (!nanoId) {
    throw new CheckoutError('nanoId obrigatório para buscar a prévia do checkout.', { nanoId });
  }

  const url = `${import.meta.env.VITE_BACKEND_URL}/store-checkouts/preview/${encodeURIComponent(nanoId)}`;
  const response = await fetch(url, {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => null);
    throw new CheckoutError(`Erro ao buscar prévia do checkout. Status: ${response.status}`, {
      nanoId,
      statusText: response.statusText,
      error: errorData,
    });
  }

  return (await response.json()) as CheckoutPreviewResponseDto;
}
